import React from "react";
import { Button } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import { FadeLoader } from "react-spinners";
import { fileSelectors, fileState, fileWordsCountError, showSizeError, fileTypeError, filesCountError } from "../reducers/uploadFileReducer";
import { detectLanguageSuccess, detectLanguageGenerator } from "../reducers/laguagesReducer";
import { connect } from "react-redux";
import { getTransUnits } from "../services/Connector";
import Error from "../components/Error";
import Row from "../components/Row";
import { ReactComponent as InfoIcon } from "../assets/images/uploadFile/info-icon.svg";
import { checkToken } from "../helpers/tokenHelper";
import { setAnimationClass, animationClass, activeStep, activeStepSelector } from "../reducers/controlReducer";
import "animate.css";
import { detectLanguage } from "../helpers/detectLanguageHelper";
import ReactGA from 'react-ga';

const UploadFile = (props) => {
  ReactGA.initialize("UA-18031446-1",);
  ReactGA.pageview(window.location.pathname + window.location.search);

  //Hendlers
  const typeErrorHandler = () => {
    props.onTypeError(true);
    props.setAnimationClass("animate__fadeInDown");
    setTimeout(() => {
      props.setAnimationClass("animate__fadeOut");
    }, 8000);
    setTimeout(() => {
      props.onTypeError(false);
    }, 9000);
  };
  const nextClickHandler = (e) => {
    let isAnonymous = checkToken(sessionStorage.getItem("token"));
    let wordsCount = 0;
    for (var word = 0; word < props.rows.length; word++) {
      let segment = props.rows[word].segmentText;
      let count = segment.split(" ").length;
      wordsCount += count;
    }
    if (wordsCount > 500 && isAnonymous) {
      props.onFileWordsCountError(true);
      props.setAnimationClass("animate__fadeInDown");
      setTimeout(() => {
        props.setAnimationClass("animate__fadeOut");
      }, 80000);
      setTimeout(() => {
        props.onFileWordsCountError(false);
      }, 9000);
      return;
    } else {
      props.setAnimationClass("animate__fadeOutLeft");
      setTimeout(() => {
        props.onNextClick({ activeStep: 1 });
      }, 500);
      props.setAnimationClass("animate__fadeInRight");
    }
  };
  const onUploadFileHandler = (e) => {
    if (e.length > 1) {
      props.onFilesCountError(true);
      props.setAnimationClass("animate__fadeInDown");
      setTimeout(() => {
        props.setAnimationClass("animate__fadeOut");
      }, 80000);
      setTimeout(() => {
        props.onFilesCountError(false);
      }, 9000);
      return;
    }
    const fileReader = new FileReader();
    fileReader.readAsText(e[0], "UTF-8");
    try {
      fileReader.onload = () => {
        if (e[0].size > 50000) {
          props.onFileSizeError(true);
          props.setAnimationClass("animate__fadeInDown");
          setTimeout(() => {
            props.setAnimationClass("animate__fadeOut");
          }, 8000);
          setTimeout(() => {
            props.onFileSizeError(false);
          }, 9000);
          return;
        }

        props.onFileUpload(fileReader.result);
        let stringToLangDetect = detectLanguage(fileReader.result);
        props.onLangDetected(stringToLangDetect);
        ReactGA.event({
          category: "PO free editor",
          action: "upload file"
        });
      };
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div className="card upload-file mt-5">
      <div className="row">
        <div className="upload-text">
          <h1>
            <span>Upload</span> file
          </h1>
        </div>
      </div>
      {props.file.wordsCountError === true && <Error className={props.animation} text={"Your file contains more than 50 words"}></Error>}
      {props.file.sizeError && <Error className={props.animation} text={"File size cannot exceed 50kB"}></Error>}
      {props.file.typeError && <Error className={props.animation} text={"This is not a PO file"}></Error>}
      {props.file.fileCountError && <Error className={props.animation} text={"You can upload only one file at a time"}></Error>}
      {!props.file.show && !props.file.sizeError && !props.file.typeError && !props.file.fileCountError && (
        <div>
          {!props.file.loading ? (
            <>
              <div className="row">
                <FileUploader
                  classes="drag-n-drop animate__animated animate__fadeIn"
                  types={["po"]}
                  handleChange={(e) => onUploadFileHandler(e)}
                  name="uploadjsfile"
                  onTypeError={() => typeErrorHandler()}
                  fileOrFiles={[]}
                  multiple={true}
                />
              </div>
              <div className="row">
                <div className="info-msg text-center animate__animated animate__fadeInDown">
                  <InfoIcon /> a free translation of PO files <span>up to 50kB</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="loader text-center">
                  <div className="row upload-loading-scrn">
                    <FadeLoader className="align-self-center " height={20} width={7} radius={10} margin={12} color={"#43B4E9"}></FadeLoader>
                    <span className="load-text">Preparing your file...</span>
                  </div>
                </div>
                <div className="info-msg text-center">
                  <InfoIcon /> a free translation of PO files <span>up to 50kB</span>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {props.file.show && (
        <>
          <div className={`animate__animated ${props.animation}`}>
            <div className={`segments-section px-2`}>
              {props.rows.map((row) => (
                <Row row={row} upload={props.rows} rows={props.rows} key={row.id} id={row.id} />
              ))}
            </div>
          </div>
          <div className="bnt-container">
            <Button className="btn-next" onClick={() => nextClickHandler()}>
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    file: fileState(state),
    animation: animationClass(state),
    rows: fileSelectors.selectAll(state),
    activeStep: activeStepSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFileUpload: (file) => dispatch(getTransUnits(file)),
    onLangDetected: (file) => dispatch(detectLanguageGenerator(file)),
    onFileSizeError: (error) => dispatch(showSizeError(error)),
    onFileWordsCountError: (error) => dispatch(fileWordsCountError(error)),
    onTypeError: (error) => dispatch(fileTypeError(error)),
    onFilesCountError: (error) => dispatch(filesCountError(error)),
    setAnimationClass: (animationClass) => dispatch(setAnimationClass(animationClass)),
    onNextClick: (step) => dispatch(activeStep(step)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
